import {useState} from 'react';
import { validateContainerNumber } from '../../../util/ContainerValidator';
import InterchangeImageGallery from './InterchangeImageGallery';
import { dialogTypes } from '../data';
import { UserType } from '../../constants/securspace-constants';
import { Grid } from '@mui/material';
import { InventoryActivityReportViewVO } from '../../../types/model/valueObject/InventoryActivityReportViewVO';
import {
  CollapsableCardContainer,
  CollapsableCardClickableContainer,
  CollapsableCardHeaderContainer,
  CollapsableCardBodyContainer,
  CollapsableCardItemContainer,
  CollapsableCardCollapseContainer,
  CollapsableCardHeaderActionsContainer,
  CollapsableCardExpandIconButton,
  CollapsableCardLabel,
  CollapsableCardValue,
  CollapsableCardBodyActionsContainer,
  ActionsMenuOpenButton,
  ActionsMenu,
  ActionsMenuItem,
  ActionsMenuItemLabel,
  useMenu
} from "@securspace/securspace-ui-kit";
import {
  CollapsableCardHeaderItem,
  CollapsableCardBodyItem
} from "../../cardComponents";

interface CardProps {
  interchange: InventoryActivityReportViewVO;
  openDialog: (type: keyof typeof dialogTypes, item: InventoryActivityReportViewVO) => void;
  account: any
}
const SupplierInterchangeCard = (props: CardProps) => {
  const {interchange, openDialog, account} = props;

  const [collapse, setCollapse] = useState<boolean>(false);
  const [isImageGalleryOpen, setIsImageGalleryOpen] = useState<boolean>(false);

  const {driverFirstName, driverLastName} = interchange;

  const formattedDriver = `${driverFirstName || ''} ${driverLastName || ''}`.trim();

  const formatEnumToLabel = (input:string) => input.replace('_', ' ');

  const toggleCollapse = () => setCollapse((prev: boolean) => !prev);

  const hasImages = interchange.inventoryGallery && interchange.inventoryGallery.length > 0;

  const {
    anchorEl: actionsMenuOpenRef,
    isOpen,
    handleClick,
    handleClose
  } = useMenu();

  const handleViewImages = () => {
    setIsImageGalleryOpen(true);
    handleClose();
  };

  const handleCloseGallery = () => {
    setIsImageGalleryOpen(false);
  };

  const handleOpenEditModal = () => {
    openDialog("EDIT", interchange)
  }

  const handleOpenMoveModal = () => {
    openDialog("MOVE", interchange)
  }

  const handleOpenDeleteModal = () => {
    openDialog("DELETE", interchange)
  }

  const handlePrint = () => {
    window.open(
      account.baseUrl + "/api/interchanges/" + interchange.id
    );
  }

  const isGateClerk = account?.userType === UserType.GATE_CLERK;

  return <CollapsableCardContainer expanded={collapse}>
    <CollapsableCardClickableContainer onClick={toggleCollapse}>
      <CollapsableCardHeaderContainer>
        <CollapsableCardHeaderItem label={'Location'} value={interchange.locationName} />
        <CollapsableCardHeaderItem label={'Buyer'} value={interchange.buyerName} />
        <CollapsableCardHeaderItem label={'Activity'} value={formatEnumToLabel(interchange.activity)} />
        <CollapsableCardHeaderItem label={'Date'} value={interchange.activityDate} />
        <CollapsableCardHeaderItem label={'Booking'} value={interchange.orderNumber} />

        <CollapsableCardHeaderActionsContainer>
          <CollapsableCardExpandIconButton expanded={collapse} />
        </CollapsableCardHeaderActionsContainer>

      </CollapsableCardHeaderContainer>
    </CollapsableCardClickableContainer>
    <CollapsableCardCollapseContainer in={collapse}>
      <CollapsableCardBodyContainer>
        <CollapsableCardBodyItem label={'Container'} value={interchange.containerNumber} />
        <CollapsableCardItemContainer>
          <CollapsableCardLabel>Container Validation</CollapsableCardLabel>
          <CollapsableCardValue>
            {validateContainerNumber(interchange.containerNumber) ? 'Valid' : 'Invalid'}
          </CollapsableCardValue>
        </CollapsableCardItemContainer>
        <CollapsableCardBodyItem label={'Truck License Plate'} value={interchange.truckLicensePlateNumber} />
        <CollapsableCardBodyItem label={'Trailer'} value={interchange.trailerNumber} />
        <CollapsableCardBodyItem label={'Chassis'} value={interchange.chassisNumber} />
        <CollapsableCardBodyItem label={'Chassis License #'} value={interchange.chassisLicensePlateNumber} />
        <CollapsableCardBodyItem label={'Seal'} value={interchange.sealNumber} />
        <CollapsableCardBodyItem label={'Size'} value={interchange.assetSize} />
        <CollapsableCardBodyItem label={'Type'} value={interchange.assetType} />
        <CollapsableCardBodyItem label={'Inventory'} value={interchange.currentInventory} />
        <CollapsableCardBodyItem label={'Dwell Time'} value={interchange.dwellTimeDisplay} />
        <CollapsableCardBodyItem label={'Dwell Time Minutes'} value={interchange.dwellTimeInMinutes} />
        <CollapsableCardBodyItem label={'Driver Name'} value={formattedDriver} />
        <CollapsableCardBodyItem label={'License'} value={interchange.driverLicenseNumber} />
        <CollapsableCardBodyItem label={'Last Updated On'} value={interchange.lastModifiedDate} />
        <CollapsableCardBodyItem label={'Last Updated By'} value={interchange.lastModifiedBy} />
        <CollapsableCardBodyItem label={'SCAC Code'} value={interchange.scacCode} />
        <CollapsableCardBodyItem label={'Notes'} value={interchange.notes} />

        <CollapsableCardBodyActionsContainer>
          <ActionsMenuOpenButton onClick={handleClick}/>
          {/* @ts-expect-error open is a valid prop. Need to edit uikit to indicate this. */}
          <ActionsMenu open={isOpen} anchorEl={actionsMenuOpenRef} onClose={handleClose}>
            {/* @ts-expect-error disabled is a valid prop. Need to edit uikit to indicate this. */}
            <ActionsMenuItem onClick={handleViewImages} disabled={!hasImages}>
              <ActionsMenuItemLabel>View Images</ActionsMenuItemLabel>
            </ActionsMenuItem>
            <ActionsMenuItem onClick={handlePrint}>
              <ActionsMenuItemLabel>Print</ActionsMenuItemLabel>
            </ActionsMenuItem>
            {
              !isGateClerk ?
              <Grid>
                <ActionsMenuItem onClick={handleOpenEditModal}>
                  <ActionsMenuItemLabel>Edit Interchange</ActionsMenuItemLabel>
                </ActionsMenuItem>
                <ActionsMenuItem onClick={handleOpenMoveModal}>
                  <ActionsMenuItemLabel>Move</ActionsMenuItemLabel>
                </ActionsMenuItem>
                <ActionsMenuItem onClick={handleOpenDeleteModal}>
                  <ActionsMenuItemLabel>Delete</ActionsMenuItemLabel>
                </ActionsMenuItem>
              </Grid>
              : ''
            }
          </ActionsMenu>
        </CollapsableCardBodyActionsContainer>
      </CollapsableCardBodyContainer>
    </CollapsableCardCollapseContainer>
    {hasImages && (
      <InterchangeImageGallery
        interchangeId={interchange.id}
        inventoryGallery={interchange.inventoryGallery}
        isOpen={isImageGalleryOpen}
        onClose={handleCloseGallery}
      />
    )}
  </CollapsableCardContainer>
};

export default SupplierInterchangeCard;